/* Vibee scroll reveal - assets/vibee-reveal.js */
(function(){
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('vibee-in');io.unobserve(e.target);}
    });
  },{threshold:0.1});
  document.querySelectorAll('.vibee-reveal').forEach(function(el){io.observe(el);});
  /* Re-observe on Shopify section re-render */
  if(window.Shopify && Shopify.designMode){
    document.addEventListener('shopify:section:load',function(){
      document.querySelectorAll('.vibee-reveal:not(.vibee-in)').forEach(function(el){io.observe(el);});
    });
  }
})();
